import { render, staticRenderFns } from "./LicitacaoFornecedorItens.vue?vue&type=template&id=0b5b321d&scoped=true"
import script from "./LicitacaoFornecedorItens.vue?vue&type=script&lang=js"
export * from "./LicitacaoFornecedorItens.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoFornecedorItens.vue?vue&type=style&index=0&id=0b5b321d&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5b321d",
  null
  
)

export default component.exports